import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { DashboardButtonGroup, PageLayouts, ReportSearchInput, SearchContextProvider } from "components/common";
import ReportNavigation from "./reportNavigation";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const MainReport: React.FC = () => {
  return (
    <SearchContextProvider>
      <PageLayouts.DashboardLayout
        entityKey={0}
        className={cssExports.reportsDashboardPanel}
        title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Reports)}
        topRightButtons={
          <DashboardButtonGroup
            buttons={[
              <ReportSearchInput
                placeholder={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Reports.SearchReports)}
              />,
            ]}
          />
        }
      >
        <ReportNavigation />
      </PageLayouts.DashboardLayout>
    </SearchContextProvider>
  );
};

export default MainReport;
